import { Component, Input } from '@angular/core';
import { legendColorCollection } from '@models/development.model';

@Component({
  selector: 'app-legends-color',
  templateUrl: './legends-color.component.html',
  styleUrls: ['./legends-color.component.scss']
})
export class LegendsColorComponent {

  @Input() 
  legendCollection: legendColorCollection[] = []
  
}
